import AdminGate from "../components/AdminGate";
import { useAdminRole } from "../services/adminAuth";
import { AlainContent } from "./AlainAdmin";
import { JayContent } from "./JayAdmin";

// Page /admin : accepte les deux mots de passe et affiche la vue
// correspondant au rôle (club → suivi Alain, admin → suivi Jay).
export default function AdminPage() {
  return (
    <AdminGate role="club">
      <AdminContent />
    </AdminGate>
  );
}

function AdminContent() {
  const role = useAdminRole();

  return role === "admin" ? <JayContent /> : <AlainContent />;
}
